import React, { Component } from 'react';
import './ShowVideoView.css'
import printYear from '../core/CollectionHelper'
import './Collections.css'

class ShowVideoView extends Component {

    render() {
        const { item } = this.props
        return (
            <div className='show-video-container'>
                <div>
                    <video className='show-video' controls
                        src={item.videoPath}
                        type={item.fileType}
                        poster={item.posterPath}
                    >
                        Извините, ваш браузер не поддерживает воспроизведение видео.
                    </video>
                </div>
                <div className='show-caption'>
                    <h3><span className='underlined'>{item.collection}</span></h3>
                    <div>{printYear(item.year, item.season)}</div>
                </div>
            </div>
        );
    }
}

export default ShowVideoView;


// WEBPACK FOOTER //
// ./src/components/ShowVideoView.jsx